import ImagePerson from "@/components/functionals/ImagePerson.vue";
//import { formatPhoneNumber } from "@/utils.js";
//import HyperlinkPhoneNumber from "@/components/functionals/HyperlinkPhoneNumber.vue";
import ColorTagsinLineFormatter from "@/components/functionals/ColorTagsinLineFormatter.vue";
import ColorType from "@/components/functionals/ColorType.vue";
import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";

export default [
  {
    prop: "ClientCode",
    name: "ClientCode",
    label: "Código de Cliente",
    width: 200,
    align: "center",
    sortable: true
  },
  {
    prop: "Name",
    name: "Name",
    label: "Nombre del Cliente",
    formatter: ImagePerson,
    width: 400,
    sortable: true
  },
  {
    prop: "CustomerClassification",
    name: "Name",
    label: "Tipo de Cliente",
    formatter: ColorType,
    width: 150,
    sortable: true,
    align: "center"
  },
  {
    prop: "Contacted",
    name: "Estado del cliente",
    label: "Estado",
    width: 150,
    sortable: true,
    formatter: ColorTagsinLineFormatter
  },
  {
    prop: "Contacted_Count",
    name: "Veces contactado",
    label: "Veces contactado",
    width: 160,
    sortable: true,
    align: "center"
    //formatter: ColorTagsinLineFormatter
  },
  {
    prop: "ContactDate",
    label: "Fecha",
    minWidth: 120,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "Subjet",
    name: "Objetivo",
    label: "Objetivo",
    width: 170,
    sortable: true
  },
  {
    prop: "Description",
    name: "Conclucion",
    label: "Conclucion",
    width: 300,
    sortable: true
  },
  /*
  {
    prop: "Email",
    name: "Email",
    label: "Email",
    minWidth: 300,
    sortable: false
  },
  */
  /*
  {
    prop: "PhoneNumber",
    name: "PhoneNumber",
    label: "Teléfono",
    formatter: HyperlinkPhoneNumber, //row => formatPhoneNumber(row.PhoneNumber),
    minWidth: 150,
    sortable: false
  },
  */
  {
    prop: "CreatedBy",
    name: "CreatedBy",
    label: "Creada por el usuario",
    minWidth: 220,
    //formatter: ImagePerson,
    sortable: true
  },
  {
    prop: "VendorName",
    name: "Vendedor",
    label: "Vendedor",
    minWidth: 220,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "SalesPersonImage"
    }
  },
  {
    prop: "CustomerServices",
    name: "Servicio",
    label: "Servicio",
    minWidth: 220,
    formatter: ImagePerson,
    attrs: {
      imgKey: "CustomerServiceImage"
    },
    sortable: true
  },
  {
    prop: "PaymentDay",
    name: "Dias de pagos",
    label: "Dias de pagos",
    width: 150,
    align: "center",
    sortable: true
  }
  /*
  {
    prop: "WebPage",
    name: "Página Web",
    label: "Página Web",
    minWidth: 220,
    sortable: false
  }
  */
];
